export const campaignIdsWithExpirationDate: number[] = [657013];

export const superiorIdsWithExpirationDate: number[] = [
  655700, 655656, 655717, 656861, 654487, 656886, 656500, 656496, 655275, 655088, 656678, 657033, 655778, 657129,
  654534, 657487, 656690, 654456, 657615
];
